export default __webpack_public_path__ + "static/media/ezrotechcrop.5454193f.png";